import React from 'react';

import styles from './BusyIndicator.module.scss';

interface BusyIndicatorOwnProps {
  isOverlaid?: boolean;
  isSmall?: boolean;
  className?: string;
}

export class BusyIndicator extends React.Component<BusyIndicatorOwnProps, {}> {
  private renderBusyIndication = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10mm"
      height="10mm"
      viewBox="0 0 56.12 56.12"
      version="1.1"
      id="svg8"
    >
      <g>
        <path
          d="M 56.122781,-1.8536333e-6 A 56.1228862,56.1228864 0 0 0 0,56.1227836 H 9.1305 A 46.998933,46.998936 0 0 1 56.122781,9.1304971 46.998933,46.998936 0 0 1 103.12803,56.1227836 46.998933,46.998936 0 0 1 56.122781,103.12803 v 9.1305 A 56.1228862,56.1228864 0 0 0 112.25853,56.1227836 56.1228862,56.1228864 0 0 0 56.122781,-1.8536333e-6 Z"
          style={{ fill: '#a9ca00', stroke: 'none' }}
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 56.12 56.12"
            to="180 56.12 56.12"
            dur="2s"
            repeatCount="indefinite"
            calcMode="spline"
            keySplines=".7 .1 .1 .9;.7 .1 .1 .9;.7 .1 .1 .9"
            values="0 56.12 56.12;0 56.12 56.12;90 56.12 56.12;180 56.12 56.12"
          />
        </path>
        <path
          d="M 56.102674,17.665982 A 38.453552,38.453552 0 0 0 17.665973,56.137325 l 8.980686,-0.0041 A 29.47287,29.47287 0 0 1 56.106721,26.646654 29.47287,29.47287 0 0 1 85.593343,56.106716 29.47287,29.47287 0 0 1 56.133275,85.593342 l 0.0041,8.980678 A 38.453552,38.453552 0 0 0 94.574024,56.102679 38.453552,38.453552 0 0 0 56.102674,17.665982 Z"
          style={{ fill: '#929292', stroke: 'none' }}
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 56.12 56.12"
            to="180 56.12 56.12"
            begin="0.15s"
            dur="2s"
            repeatCount="indefinite"
            calcMode="spline"
            keySplines=".7 .1 .1 .9;.7 .1 .1 .9;.7 .1 .1 .9"
            values="0 56.12 56.12;0 56.12 56.12;90 56.12 56.12;180 56.12 56.12"
          />
        </path>
        <path
          d="m 56.090361,35.066075 a 21.05348,21.05348 0 0 0 -21.0243,21.08357 l 9.261322,-0.01304 A 11.792151,11.792151 0 0 1 56.103398,44.327396 11.792151,11.792151 0 0 1 67.912619,56.103413 11.792151,11.792151 0 0 1 56.136597,67.912627 l 0.01304,9.261317 A 21.05348,21.05348 0 0 0 77.173937,56.090376 21.05348,21.05348 0 0 0 56.090364,35.066075 Z"
          style={{ fill: '#565656', stroke: 'none' }}
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 56.12 56.12"
            to="180 56.12 56.12"
            begin="0.3s"
            dur="2s"
            repeatCount="indefinite"
            calcMode="spline"
            keySplines=".7 .1 .1 .9;.7 .1 .1 .9;.7 .1 .1 .9"
            values="0 56.12 56.12;0 56.12 56.12;90 56.12 56.12;180 56.12 56.12"
          />
        </path>
      </g>
    </svg>
  );

  public render(): JSX.Element {
    const { isSmall, className, isOverlaid } = this.props;

    const classNames = [className];

    classNames.push(styles.busyIndicator);
    if (!isSmall) {
      classNames.push(styles.busyIndicatorBig);
    }
    if (isOverlaid) {
      classNames.push(styles.busyIndicatorOverlayed);
    }

    return (
      <div className={classNames.join(' ')}>{this.renderBusyIndication()}</div>
    );
  }
}
